/**
 * Snow Effect Script
 * Creates a beautiful snowing effect on collection pages only
 * 
 * DISABLED: Snow effect is currently turned off
 */

(function() {
  'use strict';

  // Snow effect is disabled - exit immediately
  return;

  // Check if snow effect is enabled
  // The Liquid template sets window.snowEffectEnabled if snow should be shown
  if (typeof window.snowEffectEnabled === 'undefined' || !window.snowEffectEnabled) {
    return;
  }
  
  // Additional check: verify we're on the correct page
  if (window.snowOnHomepage) {
    // On homepage - check if we're actually on the homepage
    const currentPath = window.location.pathname;
    // Homepage can be '/' or '/locale' or '/locale/' (e.g., '/hu' or '/en')
    const isHomepage = currentPath === '/' || 
                       currentPath.match(/^\/[a-z]{2}(\-[A-Z]{2})?\/?$/) ||
                       currentPath === '' ||
                       (currentPath.split('/').length === 2 && currentPath.endsWith('/'));
    if (!isHomepage) {
      return;
    }
  } else {
    // On collection page - verify we're on the correct collection
    const currentPath = window.location.pathname;
    const expectedHandle = window.snowCollectionHandle;
    if (!expectedHandle || !currentPath.includes('/collections/' + expectedHandle)) {
      return;
    }
  }

  // Configuration
  const config = {
    // Number of snowflakes (adjust based on device performance)
    flakeCount: window.innerWidth > 768 ? 50 : 30,
    // Snowflake characters
    characters: ['❄', '❅', '❆', '✻', '✼', '✽', '✾', '✿', '❀', '❁'],
    // Minimum and maximum fall duration (seconds)
    minDuration: 8,
    maxDuration: 15,
    // Minimum and maximum drift distance (px)
    minDrift: -50,
    maxDrift: 50,
    // No delay - start immediately
    minDelay: 0,
    maxDelay: 0
  };

  // Check if user prefers reduced motion
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Don't run if user prefers reduced motion
  if (prefersReducedMotion) {
    return;
  }

  // Create snow container
  function createSnowContainer() {
    const container = document.createElement('div');
    container.id = 'snow-container';
    document.body.appendChild(container);
    return container;
  }

  // Create a single snowflake
  function createSnowflake(container, startFromTop = true) {
    const snowflake = document.createElement('div');
    snowflake.className = 'snowflake';
    
    // Random character
    const character = config.characters[Math.floor(Math.random() * config.characters.length)];
    snowflake.textContent = character;
    
    // Random size
    const sizeRand = Math.random();
    if (sizeRand < 0.3) {
      snowflake.classList.add('small');
    } else if (sizeRand < 0.7) {
      snowflake.classList.add('medium');
    } else {
      snowflake.classList.add('large');
    }
    
    // Random starting position (X axis)
    const startX = Math.random() * 100;
    snowflake.style.left = startX + '%';
    
    // Random starting position (Y axis) - spread them across the viewport height
    // This prevents all flakes from appearing at the top at once
    const startY = startFromTop ? -10 : Math.random() * -50; // Start above viewport or randomly above
    snowflake.style.top = startY + '%';
    
    // Random fall duration
    const duration = config.minDuration + Math.random() * (config.maxDuration - config.minDuration);
    snowflake.style.animationDuration = duration + 's';
    
    // Random drift
    const drift = config.minDrift + Math.random() * (config.maxDrift - config.minDrift);
    snowflake.style.setProperty('--drift', drift + 'px');
    
    // No delay - start immediately
    snowflake.style.animationDelay = '0s';
    
    // Add to container first
    container.appendChild(snowflake);
    
    // Force browser to recognize the element and start animation
    // This ensures the animation starts immediately
    requestAnimationFrame(() => {
      snowflake.style.animationPlayState = 'running';
    });
    
    // Remove snowflake after animation completes
    setTimeout(() => {
      if (snowflake.parentNode) {
        snowflake.remove();
      }
    }, duration * 1000);
  }

  // Initialize snow effect
  function initSnow() {
    const container = createSnowContainer();
    
    // Create initial snowflakes - spread them out vertically
    for (let i = 0; i < config.flakeCount; i++) {
      // First batch starts from top, subsequent ones start randomly above viewport
      createSnowflake(container, i < config.flakeCount * 0.3);
    }
    
    // Continuously create new snowflakes to replace fallen ones
    setInterval(() => {
      // Only add if we have less than the target count
      const currentFlakes = container.querySelectorAll('.snowflake').length;
      if (currentFlakes < config.flakeCount) {
        createSnowflake(container, false); // New flakes start from top
      }
    }, 800); // Create new flakes more frequently for smoother effect
    
    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        // Adjust flake count based on window size
        const newCount = window.innerWidth > 768 ? 50 : 30;
        config.flakeCount = newCount;
      }, 250);
    });
  }

  // Start snow effect when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSnow);
  } else {
    initSnow();
  }

  // Pause snow when page is hidden (for better performance)
  document.addEventListener('visibilitychange', function() {
    const container = document.getElementById('snow-container');
    if (container) {
      if (document.hidden) {
        container.style.animationPlayState = 'paused';
      } else {
        container.style.animationPlayState = 'running';
      }
    }
  });

})();

